import { Routes } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject, filter, map, of, switchMap, take, tap } from 'rxjs';
import { Company, Paging, Project, ReportWidget, Site } from 'app/core/models/base.model';
import { environment } from 'environments/environment';
import { ApiProjectService } from 'app/core/apis/api-project.service';
import { merge } from 'lodash';
import { UserDataService } from 'app/core/datas/user-data';
import { ProjectFields } from 'app/app.config';
import { ApiSiteService } from 'app/core/apis/api-sites.service';
import { ApiMeService } from 'app/core/apis/api-me.service';

@Injectable({ providedIn: 'root' })
export class ProjectService {
    private _userDataSvc = inject(UserDataService);
    private _apiSvc = inject(ApiProjectService);
    private _projectid: BehaviorSubject<number> = new BehaviorSubject(0);
    private _project: BehaviorSubject<Project> = new BehaviorSubject(null);

    /**
     * Getter
     */

    get projectid$(): Observable<number> {
        return this._projectid.asObservable();
    }

    get project$(): Observable<Project> {
        return this._project.asObservable();
    }

    //update value
    updateProjectId(id: number) {
        this._projectid.next(id);
    }

    updateProject(obj: Project) {
        this._project.next(obj);
    }

    //api
    getRemoteProjectById(id: number, params = {}): Observable<Project> {
        let defaultParams = {
            fields: ProjectFields
        }
        const mergedParams = merge({}, defaultParams, params);

        return this._apiSvc.apiGetObject(id, mergedParams).pipe(
            tap({
                next: response => {
                    this._userDataSvc.addSelectedProject(response);
                    this.updateProject(response);
                }
            }),
        );
    }

}